<template>
  <div v-show="show" class="root fixed w-screen h-full z-20">
    <div ref="loadingAnimation" class="loading-wrapper w-3/5 my-0 mx-auto" />
  </div>
</template>

<script>
import lottie from 'lottie-web';
import loading from '@/assets/animations/loading.json';

export default {
  data: () => ({
    animation: null,
    animationData: loading,
    show: false,
  }),
  mounted() {
    this.animation = lottie.loadAnimation({
      container: this.$refs.loadingAnimation,
      renderer: 'svg',
      loop: true,
      autoplay: true,
      animationData: this.animationData,
    });
  },
  beforeDestroy() {
    if (this.animation) {
      this.animation.destroy();
    }
  },
  methods: {
    setShow(data) {
      this.show = data;
    },
  },
};
</script>

<style lang="scss" scoped>
.root {
  background-color: rgba(255, 255, 255, 0.75);
}

.loading-wrapper {
  height: 65%;
}
</style>
